/*
 * DecoNova — Helpers partagés
 * Utilisés par deconova-pack-selector et deconova-configurator.
 * Zéro dépendance, vanilla JS.
 */

(function () {
  'use strict';

  const NS = (window.DecoNova = window.DecoNova || {});

  // ───── Format prix ────────────────────────────────────────────────
  // Shopify expose Shopify.currency et money_format via Liquid.
  // Fallback Intl.NumberFormat si indisponible.

  NS.formatMoney = function (cents, locale, currency) {
    const amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(locale || 'fr-BE', {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: 2,
      }).format(amount);
    } catch (_) {
      return amount.toFixed(2) + ' €';
    }
  };

  // ───── Parse du catalogue de couleurs (metaobjets) ─────────────────
  // Appelé avec le résultat de `{{ shop.metaobjects.color.values | json }}`.
  // Retourne les coloris actifs, triés par position, avec {name,hex,topUrl,bottomUrl,handle}.

  NS.parseColorCatalog = function (raw) {
    if (!raw || !Array.isArray(raw)) return [];
    const entries = raw
      .map(function (entry) {
        // Les champs sont accessibles via entry.fields dans l'API Liquid
        // Quand sérialisé via | json, on récupère un objet avec les clés des champs.
        const fields = entry.fields || entry;
        const isActive = typeof fields.is_active === 'boolean'
          ? fields.is_active
          : fields.is_active !== false;
        if (!isActive) return null;

        return {
          handle:     entry.handle || fields.handle || '',
          name:       fields.name  || '',
          hex:        fields.hex   || '#000000',
          topUrl:     (fields.layer_top    && (fields.layer_top.url    || fields.layer_top)) || null,
          bottomUrl:  (fields.layer_bottom && (fields.layer_bottom.url || fields.layer_bottom)) || null,
          position:   Number(fields.position) || 999,
        };
      })
      .filter(Boolean);

    entries.sort(function (a, b) { return a.position - b.position; });
    return entries;
  };

  // ───── Add to cart ────────────────────────────────────────────────
  // payload = { id: variantId, quantity: 1, properties: {...} }
  // On supporte aussi { items: [...] } pour batch.

  NS.addToCart = function (payload) {
    const body = payload && payload.items
      ? JSON.stringify({ items: payload.items })
      : JSON.stringify({ items: [payload] });

    return fetch('/cart/add.js', {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept':       'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: body,
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) {
          throw new Error(err.description || err.message || 'Erreur panier');
        }, function () { throw new Error('Erreur panier (HTTP ' + res.status + ')'); });
      }
      return res.json();
    });
  };

  // ───── Notifier le drawer/cart Tinker ──────────────────────────────
  // Tinker écoute plusieurs événements ; on émet les plus courants.

  NS.notifyCartChanged = function () {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('on:cart:add'));
    // Récupère l'état panier pour cart bubble
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  };

  // ───── Utilitaire : debounce (pour repeintes canvas) ───────────────

  NS.debounce = function (fn, ms) {
    let t;
    return function () {
      const ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms || 16);
    };
  };

  // ───── Génère les properties ligne-article pour un pack ────────────
  // slots = [{ top: {name,hex}, bottom: {name,hex} }, ...]
  // Préfixe `_` masque la propriété au client.

  NS.buildPackProperties = function (format, packSize, slots) {
    const props = {
      '_format':    format,
      '_pack_size': String(packSize),
    };
    slots.forEach(function (slot, i) {
      const n = i + 1;
      const topName    = (slot.top    && slot.top.name)    || '—';
      const bottomName = (slot.bottom && slot.bottom.name) || topName;
      // Préfixe sans underscore => visible par le client dans le panier
      props['Article ' + n + ' — Couleur haut'] = topName;
      props['Article ' + n + ' — Couleur bas']  = bottomName;
    });
    return props;
  };
})();
